
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Col, Row} from "react-bootstrap"
import styled from "styled-components"

import id from "@irati/utils/id"
import Form from "@irati/ui/src/Form"
import {H3} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import {Hr} from "@irati/ui/src/Layout"
import {ValidationButtonRouterLink} from "@irati/ui/src/Link"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {validatedScreen} from "@irati/utils/validation"
import {
  ActionBoardUrl,
  AutoQuestionCount,
  IncludeActionBoard,
  NextTriggerAtOverride,
  PeriodValue,
  SendToAll,
  StartAt,
  TeamsIds,
  Tenant
} from "@irati-web/fields/schedule"

import {CustomisationSummary, ScheduleStatusButton, ScheduleSummary} from "../"
import {isScheduleEnabled} from "../../../helpers/schedule"


/**
 * Small styled components
 */
const BlockValidationButtonRouterLink = styled(ValidationButtonRouterLink)`display: block;`
const StyledIncludeActionBoard = styled(IncludeActionBoard)`margin-bottom: 20px;`
const WarningPara = styled(Para)`margin-bottom: 20px; max-width: 300px;`

const OuterRow = styled(Row)`
  display: inline;

  ${minWidthMedia.desktop`
    display: flex;
  `}
`

const OuterRightCol = styled(Col)`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding-top: 60px;

    ${minWidthMedia.desktop`
      padding-top: 0;
    `}
`


class ScheduleSettingsForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    reload: PropTypes.func,
    schedule: PropTypes.object
  }

  static defaultProps = {
    onSubmit: Promise.resolve(),
    onChange: Promise.resolve(),
    reload: Promise.resolve(),
    schedule: null
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("SurveySetupForm", this.props)
    const {schedule, onChange, onSubmit, reload} = this.props
    const scheduleIsEnabled = isScheduleEnabled(schedule)
    const mdColWidth = scheduleIsEnabled ? 6 : 12
    const mdInnerColWidth = scheduleIsEnabled ? 12 : 6
    const scheduleIsNew = !schedule.lastTriggeredAt
    const sendToAll = schedule.preferences.sendToAll
    if (!schedule) return null

    return (
      <Form id={idNamespace}>
        <OuterRow>
          <Col xs={12} md={mdColWidth}>
            <Row>
              <Col xs={12} md={mdInnerColWidth}>
                <H3>Schedule</H3>
                <ScheduleSummary schedule={schedule} />
              </Col>
              {!scheduleIsEnabled && (
                <Col xs={12} md={6}>
                  <PeriodValue schedule={schedule} onChange={onChange} />
                  <AutoQuestionCount schedule={schedule} onChange={onChange} />
                  <SendToAll
                    schedule={schedule}
                    onChange={onChange} />
                  {!sendToAll && <TeamsIds schedule={schedule} onChange={onChange} />}
                  {scheduleIsNew
                    ? <StartAt schedule={schedule} onChange={onChange} />
                    : <NextTriggerAtOverride
                      schedule={schedule}
                      onChange={onChange}
                      label="insights.fields.surveySettings.nextTriggerAtOverride.label" />}
                </Col>
              )}
            </Row>

            <Hr />

            <Row>
              <Col xs={12} md={mdInnerColWidth}>
                <H3>Customisation and action board</H3>
                <CustomisationSummary schedule={schedule} />
              </Col>
              {!scheduleIsEnabled && (
                <Col xs={12} md={6}>
                  <Tenant schedule={schedule} onChange={onChange} />
                  <StyledIncludeActionBoard schedule={schedule} onChange={onChange} />
                  {schedule.preferences.includeActionBoard &&
                  <ActionBoardUrl schedule={schedule} onChange={onChange} />}

                  <BlockValidationButtonRouterLink
                    async
                    primary
                    onClick={onSubmit}
                    id={id("submit-btn", idNamespace)}>
                    Save
                  </BlockValidationButtonRouterLink>
                </Col>
              )}
            </Row>
          </Col>

          {scheduleIsEnabled && (
            <OuterRightCol xs={12} md={6}>
              <WarningPara>
                In order to edit your survey settings, we&apos;ll need to pause your survey first.
              </WarningPara>
              <ScheduleStatusButton
                pauseCopy="Pause and edit"
                schedule={schedule}
                onChange={reload} />
            </OuterRightCol>
          )}
        </OuterRow>
      </Form>
    )
  }
}

export default validatedScreen(ScheduleSettingsForm, "ScheduleSettings")
